module.exports = __webpack_public_path__ + "img/CREE_S.634915d3.png";